import {user} from "@/functions/user";
import {getBannerProducts} from "@/functions/ProductBanner";
import {isPreparerEnabled} from "@/functions/getPreparerContext";

const getUrlParameters = () => {
    let query = window.location.search;
    let urlParams = new URLSearchParams(query);
    let paramsArray = []
    let queryArray
    let currentParamsArray = []

		sessionStorage.removeItem('goto_page')

    if (urlParams.has('FREEFILE')) {
        sessionStorage.setItem('isFreeFile', 'true')
    }

    if (urlParams.has('NEWTAX')) {
        sessionStorage.setItem('NEWTAX', 'true')
    }

    query = query.replace('?','')
    queryArray = query.split('&')
    queryArray.forEach(param => {
        if (param.includes('errorMessage=')) {
            sessionStorage.setItem('encodedErrorMessage', param.replace('errorMessage=',''))
        }
    })

    urlParams.forEach((value, key) => {
        // Don't persist a preparer redirect_uri when the feature is disabled.
        if (key === 'redirect_uri' && value?.includes('preparer') && !isPreparerEnabled()) {
            sessionStorage.removeItem('redirect_uri')
            return
        }
        if (value && (value !== 'errorMessage' && key !== 'appYear')) {
            sessionStorage.setItem(key, value)
        }
        else {
            paramsArray.push(key)
        }
    })

    if (sessionStorage.getItem('urlParamString')) {
        currentParamsArray = JSON.parse(sessionStorage.getItem('urlParamString'))
        paramsArray.forEach((value)=> {
            if (!currentParamsArray.includes(value)) {
                currentParamsArray.push(value)
            }
        })

        sessionStorage.setItem('urlParamString', JSON.stringify(currentParamsArray))
    }
    else {
        sessionStorage.setItem('urlParamString', JSON.stringify(paramsArray))
    }

    getBannerProducts()

    user.platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown'
}

export default getUrlParameters